import { render, staticRenderFns } from "./roomCreateFeeList.vue?vue&type=template&id=cb4f5dfa&scoped=true"
import script from "./roomCreateFeeList.vue?vue&type=script&lang=js"
export * from "./roomCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./roomCreateFeeList.vue?vue&type=style&index=0&id=cb4f5dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4f5dfa",
  null
  
)

export default component.exports